import { blocks } from '@yola/ws-sdk';

const matchBlockElement = (element) =>
  element.matches(
    `[id^=${blocks.constants.BLOCK_ID_PREFIX}]:not([id^=${blocks.constants.WIDGET_ID_PREFIX}])`
  );

export default matchBlockElement;
